module.exports = __webpack_public_path__ + "static/media/PPT-ProFACT-Training-Spanish-translated-by-ARSP-FINAL.cfbc5e2f.9260ab13.pdf";